var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.827 6l-.23 6m-3.193 0l-.23-6m6.644-2.14c.228.035.456.072.682.11m-.682-.11l-.711 9.255A1.5 1.5 0 0 1 9.61 14.5H4.389a1.5 1.5 0 0 1-1.496-1.385L2.182 3.86m9.636 0A32.066 32.066 0 0 0 9.5 3.596m-8 .375c.226-.04.454-.076.682-.11m0 0A32.072 32.072 0 0 1 4.5 3.595m5 0v-.61c0-.787-.607-1.443-1.393-1.468a34.62 34.62 0 0 0-2.214 0c-.786.025-1.393.681-1.393 1.467v.611m5 0a32.444 32.444 0 0 0-5 0",
    stroke: "#667085",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteNewIcon);
export default __webpack_public_path__ + "static/media/delete-new-icon.e63c4c81068adc278bfd95ad40bfc913.svg";
export { ForwardRef as ReactComponent };